import React from "react";

import { Box, Paper, Typography } from "@mui/material";

import { IKeyMetricsItem } from "./type";

export const KeyMetricsItem: React.FC<
  IKeyMetricsItem & { extraContent?: React.ReactNode }
> = ({ amount, extraContent, title }) => (
  <Paper elevation={0}>
    <Box display="flex" flexDirection="column" gap="8px" px={2}>
      <Typography variant="body1">{title}</Typography>
      <Typography variant="h3">{amount}</Typography>
      {extraContent}
    </Box>
  </Paper>
);
